"use client";

import { useEffect, useState } from "react";
import type { ItinerarySuccess } from "@/lib/planner/api-types";
import { routeTrust } from "@/lib/planner/route-trust";

export function RouteTrustSummary({ plan }: { plan: ItinerarySuccess }) {
  const [clock, setClock] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setClock(Date.now()), 60_000);
    return () => window.clearInterval(timer);
  }, []);
  const trust = routeTrust(plan, undefined, clock);
  return <div className="mb-4 grid gap-3 sm:grid-cols-3" aria-label="What this recommendation is based on">
    {([
      ["For you", trust.fit], ["Expected conditions", trust.conditions], ["Evidence", trust.evidence],
    ] as const).map(([title, detail]) => <section key={title} className="min-w-0 rounded-xl border border-border-light bg-warm-bg p-3">
      <h3 className="text-xs font-bold uppercase tracking-wide text-text-muted">{title}</h3>
      <p className="mt-2 text-sm font-semibold text-navy">{detail.label}</p>
      <details className="mt-1 text-xs text-text-muted">
        <summary className="flex min-h-[44px] cursor-pointer items-center font-semibold text-navy">What this means</summary>
        <p className="leading-relaxed">{detail.detail}</p>
        {"dates" in detail && detail.dates.length > 0 && <ul className="mt-2 space-y-2">{detail.dates.map(date => <li key={date}>{date}</li>)}</ul>}
      </details>
    </section>)}
  </div>;
}
